// @flow

import React from 'react';
import styled from 'styled-components';
import { Button } from 'antd';

const StyledButton = styled(Button)`
  height: 32px;
  line-height: 30px;
  width: ${({ width }) => width && width};
  padding: ${({ width }) => width && '0px'};
  border-radius: 0;
  font-size: 14px;
  text-align: center;
  transition: none;
  cursor: pointer;

  /* default */
  &,
  &:active,
  &:focus {
    background-color: #fff;
    border-color: #e6e6e6;
    color: #333;
  }

  &:hover {
    color: #fff !important;
    border-color: #e8b342;
    background-color: #e8b342;
  }

  &.ant-btn-clicked::after {
    animation: none;
  }

  &.ant-btn-primary {
    background-color: #e8b342;
    border-color: #e8b342 !important;
    color: #fff;

    &:not(:disabled):hover {
      opacity: 0.7;
    }
  }

  &[disabled],
  &[disabled]:active,
  &[disabled]:hover,
  &[disabled]:focus {
    background-color: #d4d4d4;
    border-color: #d4d4d4 !important;
    color: #fff;
  }

  /* size: small */
  &.ant-btn-sm {
    height: 28px;
    line-height: 26px;
  }

  i {
    display: inline-block;
    margin-right: 5px;
    vertical-align: bottom;
  }
`;

const ButtonGroup = styled(Button.Group)`
  display: flex;

  button {
    flex: 1;
  }
`;

type Props = {
  active: boolean,
  type: string | boolean,
  block: boolean,
  width: string,
};

const ButtonWrapper = ({
  type, block, width, ...others
}: Props) => {
  const _type = type || '';
  const _width = width || (block && '100%');

  return <StyledButton type={_type} width={_width} {...others} />;
};

ButtonWrapper.Group = ButtonGroup;

export default ButtonWrapper;
